import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Label,
  Row,
  Table,
  CardFooter,
  Button,
  Spinner,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import Logo from "../navbar/Logo";
import SupportLink from "../root/support/components/SupportLink";
import ButtonIcon from "../UI/buttons/ButtonIcon";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faUndo } from "@fortawesome/free-solid-svg-icons";
import { Toast } from "../UI/toast/Toast";
import { updateStatusManagerPayment } from "../../helpers/api/finance";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const ManagerServicePaymentDetails = () => {
  const moduleBase = useModuleBase();
  const history = useHistory();

  const { role, token } = useSelector((state) => state.auth.user);
  const { paymentId, charge, condominiumId, id } = useParams();
  const { baseCurrency } = useContext(CurrencyContext);

  const {
    state: { payment },
  } = useLocation();

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!payment) {
      Toast.fire({
        type: "error",
        title: "Ocurrió un error al cargar los datos",
      });
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment]);

  const approve = () => {
    setSubmitting(true);
    updateStatusManagerPayment(paymentId, "accepted")
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({ type: "success", title: "Pago aceptado exitosamente" });
          history.push(`/root/condominiums/${id}/payments/${charge}`);
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  const refuse = () => {
    setSubmitting(true);
    updateStatusManagerPayment(paymentId, "refused")
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({ type: "success", title: "Pago rechazado exitosamente" });
          history.push(`/root/condominiums/${id}/payments/${charge}`);
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <PageHeader
        title="Detalle de pago"
        titleTag="h2"
        description={
          role === "manager"
            ? "Visualiza tu pago realizado."
            : "Visualiza el pago del condominio"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card className="mb-3">
        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Pago #{payment.id}</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                disabled
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="print"
                disabled
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
              {!submitting ? (
                role === "root" ? (
                  payment?.status === "processing" ? (
                    <>
                      <ButtonIcon
                        color="falcon-success"
                        size="sm"
                        icon={faCheck}
                        className="mb-2 mr-2  mb-sm-0"
                        onClick={() => approve()}
                      >
                        Aprobar pago
                      </ButtonIcon>
                      <ButtonIcon
                        color="falcon-danger"
                        size="sm"
                        icon={faTimes}
                        className="mb-2 mb-sm-0"
                        onClick={() => refuse()}
                      >
                        Rechazar pago
                      </ButtonIcon>
                    </>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )
              ) : (
                <Button color="falcon-default" size="sm">
                  <Spinner size="sm" />
                </Button>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Row className="align-items-center text-center mb-3">
            <Col sm={6} className="text-sm-left">
              <div className="text-sm-left col-sm-6">
                <Logo width={150} />
              </div>
            </Col>
            <Col className="text-sm-right mt-3 mt-sm-0">
              <h2 className="mb-3">Pago a Homelan</h2>
              <Label className="mb-0">Servicio:</Label>
              <p className="fs--1 mb-0">
                <b>{payment.charge.charge.number_properties} propiedades</b>
              </p>
              <Label className="mb-0">Fecha de realización:</Label>
              <p className="fs--1 mb-0">
                <b>{moment(payment.created_at).format("DD/MM/YYYY h:mm A")}</b>
              </p>
              <Label className="mb-0">Precio del servicio:</Label>
              <p className="fs--1 mb-0">
                <b>
                  <NumberFormat
                    prefix={`${baseCurrency.symbol} `}
                    thousandSeparator
                    decimalScale={2}
                    fixedDecimalScale
                    displayType="text"
                    value={payment.charge.charge.price}
                  />
                </b>
              </p>
            </Col>
            <Col xs={12}>
              <hr />
            </Col>
          </Row>
          <Row className="justify-content-between align-items-center">
            <Col>
              <h6 className="text-500">Factura de pago para</h6>
              <h5>{payment.charge.condominium.name}</h5>
              <p className="fs--1">{payment.charge.condominium.address}</p>
            </Col>
            <Col sm="auto" className="ml-auto">
              <div className="table-responsive">
                <Table striped size="sm" borderless className="fs--1">
                  <tbody>
     
                    <tr>
                      <th className="text-sm-right">Fecha de pago:</th>
                      <td>{moment(payment.created_at).format("DD/MM/YYYY")}</td>
                    </tr>
                    <tr
                      className={
                        payment.status === "processing"
                          ? "alert-warning  font-weight-bold"
                          : payment.status === "refused"
                          ? "alert-danger  font-weight-bold"
                          : payment.status === "canceled"
                          ? "alert-danger font-weight-bold"
                          : "alert-success font-weight-bold"
                      }
                    >
                      <th className="text-sm-right">Estado:</th>
                      <td>
                        {payment.status === "processing"
                          ? "Pendiente"
                          : payment.status === "refused"
                          ? "Pago rechazado"
                          : payment.status === "canceled"
                          ? "Cancelado"
                          : "Aprobado"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          <div className="table-responsive mt-4 fs--1">
            <Table striped className="border-bottom">
              <thead>
                <tr /* className="bg-primary text-white" */>
                  <th className="border-0">Cuenta</th>
                  <th className="border-0">Descripción</th>
                  <th className="border-0 text-center">Fecha</th>
                  <th className="border-0 text-right">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">{payment.id}</td>
                  <td className="align-middle">
                    <p className="mb-0">
                      Pago de {payment.charge.charge.number_properties}{" "}
                      Propiedades
                    </p>
                  </td>
                  <td className="align-middle text-center">
                    {moment(payment.created_at).format("DD/MM/YYYY")}
                  </td>
                  <td className="align-middle text-right">
                    <NumberFormat
                      displayType="text"
                      prefix={`${baseCurrency.symbol} `}
                      allowedDecimalSeparators={true}
                      decimalScale={2}
                      fixedDecimalScale
                      thousandSeparator={true}
                      value={payment.amount}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <Row noGutters className="justify-content-end">
            {payment.voucher && payment.voucher !== "false" && (
              <Col>
                <Table striped size="sm" borderless className="fs--1 text-left">
                  <thead>
                    <th className="border-0">Comprobante de pago</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                      <div className="App mt-3">
                            <img
                              src={payment?.voucher}
                              style={{
                                height: "400px",
                                width: "400px",
                                maxHeight: "400px",
                                maxWidth: "400px",
                                backgroundRepeat: "no-repeat",
                              }}
                              alt="Factura"
                            />
                          </div>
        {/*                 <div className="d-flex align-items-center justify-content-start">
                          <div
                            style={{
                              backgroundImage: `url('${
                                import.meta.env.VITE_API_URL
                              }/view/image/${token}?path=${
                                payment.voucher
                              }&size=large')`,
                              backgroundSize: "contain",
                              height: "400px",
                              width: "400px",
                              maxHeight: "400px",
                              maxWidth: "400px",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                        </div> */}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            )}
            <Col xs="auto">
              <Table striped size="sm" borderless className="fs--1 text-right">
                <tbody>
                  <tr className="border-top">
                    <th className="text-900">Total:</th>
                    <td className="font-weight-semi-bold">
                      <NumberFormat
                        className="text-right"
                        displayType="text"
                        allowedDecimalSeparators={true}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={`${baseCurrency.symbol} `}
                        value={payment.amount}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="border-top">
          <Row noGutters className="justify-content-start">
            <Button
              color="falcon-default"
              className="text-dark mr-2"
              onClick={() => history.goBack()}
            >
              <FontAwesomeIcon icon={faUndo} className="mr-2" />
              Volver
            </Button>
            <Button
              color="falcon-default"
              className="text-dark"
              onClick={() =>
                history.push(
                  `/dashboard/${moduleBase}/${condominiumId}/my/service/${charge}`
                )
              }
            >
              <FontAwesomeIcon icon={faList} className="mr-2" />
              Listado de pagos
            </Button>
          </Row>
        </CardFooter>
      </Card>
    </>
  );
};

export default ManagerServicePaymentDetails;
